<template>
  <nav id="wheel-nav">
    <div></div>
    <h1>Wheel of Yugioh</h1>
    <button
      :class="['setting-button', { close: showSetting }]"
      @click="showSetting = true"
      :disabled="!wheels[current].showSetting"
    >
      <div class="setting-icon"></div>
    </button>
  </nav>
  <main>
    <Wheel
      v-for="(wheel, index) in wheels"
      :key="wheel.id"
      :id="wheel.id"
      :theme="wheel.theme"
      :sections="wheel.data"
      :showImage="wheel.showImage"
      :showType="wheel.showType"
      :showResult="wheel.showResult"
      :showText="wheel.showText"
      :noBorder="wheel.noBorder"
      :fontSize="wheel.fontSize"
      v-show="current === index"
    />
  </main>
  <div class="menu">
    <button
      v-for="(wheel, index) in listWheels"
      :key="wheel.name"
      :class="[{ 'select-wheel': true, active: current === index }]"
      @click="current = index"
    >
      {{ wheel.name }}
    </button>
  </div>
  <h2>Master Wheel</h2>
  <div class="menu">
    <button
      v-for="(wheel, index) in masterWheels"
      :key="wheel.name"
      :class="[
        { 'select-wheel': true, active: current === index + listWheels.length }
      ]"
      @click="current = index + listWheels.length"
    >
      {{ wheel.name }}
    </button>
  </div>
  <h2>Secret Packs</h2>
  <div class="menu">
    <button
      v-for="(wheel, index) in secretWheels"
      :key="wheel.name"
      :class="[
        {
          'select-wheel': true,
          active: current === index + listWheels.length + masterWheels.length
        }
      ]"
      @click="current = index + listWheels.length + masterWheels.length"
    >
      {{ wheel.name }}
    </button>
  </div>
  <transition name="fade">
    <div v-show="showSetting" class="setting">
      <button class="close-button" @click="showSetting = false"></button>
      <div v-show="!wheels[current].editable">
        <label
          :class="['toggle-button', { active: card.active }]"
          v-for="card in wheels[current].data"
          :key="card.id || card.name"
          :for="card.name"
        >
          <input :id="card.name" type="checkbox" v-model="card.active" />
          {{ card.name }}
        </label>
      </div>
      <div v-show="wheels[current].editable" class="editable">
        <div
          class="row"
          v-for="(card, index) in wheels[current].data"
          :key="card.id || card.name"
        >
          <div class="content text">{{ card.name }}</div>
          <button class="button remove" @click="removeCard(index)">
            Remove
          </button>
        </div>
        <div class="row">
          <textarea class="content input" v-model="addCardName" />
          <div class="button-group">
            <button class="button add" @click="addCard">Add</button>
            <button class="button remove-all" @click="removeAllCards">
              Remove All
            </button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import Wheel from "./Wheel.vue";
import data from "./data";

export default {
  name: "App",
  components: {
    Wheel
  },
  data() {
    return {
      current: 0,
      editing: false,
      addCardName: "",
      showSetting: false,
      wheels: data
    };
  },
  computed: {
    listWheels() {
      return this.wheels.filter(wheel => !wheel.group);
    },
    masterWheels() {
      return this.wheels.filter(wheel => wheel.group === "Master Wheel");
    },
    secretWheels() {
      return this.wheels.filter(wheel => wheel.group === "Secret Packs");
    }
  },
  mounted() {
    this.wheels.forEach((wheel, index) => {
      if (wheel.editable && localStorage.getItem(wheel.name)) {
        try {
          this.wheels[index].data = JSON.parse(
            localStorage.getItem(wheel.name)
          );
        } catch (e) {
          localStorage.removeItem(wheel.name);
        }
      }
    });
  },
  methods: {
    removeCard(index) {
      this.wheels[this.current].data.splice(index, 1);
      this.saveLocalStorage();
    },
    removeAllCards() {
      this.wheels[this.current].data = [];
    },
    addCard() {
      const names = this.addCardName
        .split("\n")
        .flatMap(card => card.split("\t").flatMap(card => card.split(",")))
        .filter(card => card);

      names.forEach(name => {
        this.wheels[this.current].data.push({
          name,
          value: 1,
          active: true
        });
      });
      this.addCardName = "";
      this.saveLocalStorage();
    },
    saveLocalStorage() {
      localStorage.setItem(
        this.wheels[this.current].name,
        JSON.stringify(this.wheels[this.current].data)
      );
    }
  }
};
</script>

<style lang="scss">
*,
*:before,
*:after {
  box-sizing: border-box;
}

@font-face {
  font-family: "Matrix";
  src: url("./assets/fonts/matrix-book.ttf");
}

html,
body {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  background: #eee;
}

#app {
  font-family: "Matrix", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100%;
}

#wheel-nav {
  display: grid;
  grid-template-columns: 70px auto 70px;
  grid-template-rows: auto;
  grid-template-areas: "left center right";
  align-items: center;
  padding: 20px;
  margin-bottom: 0;
  grid-column-gap: 8px;
  position: relative;

  h1 {
    font-family: "Matrix", Helvetica, Arial, sans-serif;
    font-weight: bold;
    grid-area: center;
    margin: 0;
    text-transform: uppercase;
    grid-area: center;
    font-size: 32px;
    letter-spacing: 4px;
  }

  .setting-button {
    position: absolute;
    top: 20px;
    right: 20px;
  }
}

main {
  padding: 20px;
}

.wheel {
  margin: 0 auto;
}

.menu {
  display: flex;
  flex-wrap: wrap;
  padding: 20px 20px 40px;
  gap: 5px;
  max-width: 600px;
  margin: 0 auto;
}

.select-wheel {
  font-size: 18px;
  background: none;
  border: 1px solid #aaa;
  padding: 8px 12px;
  margin: 0;
  text-transform: capitalize;
  flex: 1;
  cursor: pointer;
  border-radius: 4px;

  &.active {
    background: #000;
    color: white;

    &:hover {
      background: #333;
    }
  }

  &:hover {
    background: #ddd;
  }

  & + .select-wheel {
    margin-left: -1px;
  }
}

.setting-button {
  z-index: 5;
  background: none;
  border: 0;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  &:disabled,
  &.close {
    display: none;
  }
}

.close-button {
  position: absolute;
  top: 20px;
  right: 20px;
  width: 40px;
  height: 40px;
  padding: 0;
  margin: 0;
  border: 0;
  background: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 6;

  &::before,
  &::after {
    content: "";
    position: absolute;
    display: block;
    border-radius: 5px;
    width: 28px;
    height: 0;
    border: 2px solid #000;
    background: #000;
    border-radius: 2px;
    box-shadow: none;
    transform: translate3d(0, 0, 0);
  }

  &::before {
    transform: translate3d(0, 0, 0) rotate(45deg);
  }
  &::after {
    transform: translate3d(0, 0, 0) rotate(-45deg);
  }
}

.setting-icon {
  position: relative;
  width: 36px;
  height: 4px;
  border-radius: 2px;
  color: #000;
  background: #000;
  box-shadow: 0 10px, 0 -10px;
  transition: all 0.3s;

  &:before {
    content: "";
    position: absolute;
    display: block;
    width: 10px;
    height: 10px;
    border: 3px solid #000;
    border-radius: 5px;
    background: white;
    z-index: 1;
    top: 0;
    left: 0;
    transform: translate3d(4px, -3px, 0);
    transition: all 0.3s;
  }

  &:after {
    content: "";
    position: absolute;
    display: block;
    width: 10px;
    height: 10px;
    border: 3px solid #000;
    border-radius: 5px;
    background: white;
    z-index: 1;
    top: 0;
    left: 0;
    transform: translate3d(14px, -13px, 0);
    box-shadow: 0px 20px 0px -3px white, 0 20px 0 0 black;
    transition: all 0.3s;
  }
}

.setting {
  position: fixed;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.95);
  z-index: 4;
  padding: 80px 20px;
  overflow: auto;
}

.editable {
  display: flex;
  width: 100%;
  max-width: 400px;
  flex-direction: column;
  margin: 0 auto;

  .row {
    display: flex;
    align-items: center;
    margin-bottom: 16px;

    .content {
      flex: auto;
      text-align: left;
      padding: 4px 12px;
      font-size: 20px;

      &.text {
        padding: 4px 0;
      }

      &.input {
        border: 1px solid #333;
        height: 150px;
      }
    }

    .button {
      display: inline-block;
      font-size: 20px;
      padding: 4px 12px;
      margin-left: 8px;
      cursor: pointer;
      border: 1px solid transparent;
      border-radius: 8px;
      background: #2ecc71;
      color: white;
      width: 140px;

      &.remove {
        background: #e74c3c;
      }

      &.add {
        align-self: flex-start;
        margin-bottom: 20px;
      }

      &.remove-all {
        background: #333;
      }
    }
  }
}

.toggle-button {
  display: inline-block;
  font-size: 24px;
  padding: 4px 12px;
  margin: 8px;
  cursor: pointer;
  border: 1px solid transparent;
  border-radius: 8px;

  &.active {
    border-color: #333;
  }

  input {
    display: none;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
